import request from '../util/SuperagentUtils';
import {blogEndpoints} from "./api-endpoints";

export const getBlogPost = (id: string) => {
  return request.get(`${blogEndpoints.search}/${id}`);
};

export const getRelatedBlogs = (contentGroupId: string, limit: number, offset: number) => {
  return request.get(`${blogEndpoints.search}?contentGroupId=${contentGroupId}&limit=${limit}&offset=${offset}`);
};
